import React from 'react';
import {PageViewHeader} from 'components-lib';

export const UploadFileHeader = () => {
  return (
    <PageViewHeader
      fullFlexWidth
      withColumnPadding={false}
      heading="Upload File"
      headingColor="textPrimary"
      withBackButton={false}
    />
  );
};
